export default {
    bindFunctions: (bindTo, functions) => {
        functions.forEach(funcao => {
            bindTo[funcao] = bindTo[funcao].bind(bindTo);
        });
    }
}